<template>
  <el-dialog
    id="edit-modal"
    class="form-modal"
    :visible.sync="editVisible"
    v-loading="editProcessing"
    :fullscreen="true"
    :show-close="false"
    :modal="false"
  >
    <div id="edit-modal-header" class="modal-header">
      <div class="modal-header-layout flex grid-6 align-center">
        <h1 class="modal-title col-2">Edit Button Layout</h1>
        <div class="modal-actions col-2">
          <el-button type="primary" @click="editOperation">
            Edit
          </el-button>
          <el-button
            type="default"
            class="hidden-xs-only"
            @click="cancelOperation"
            >Cancel</el-button
          >
          <el-button
            type="default"
            icon="el-icon-close"
            class="hidden-sm-and-up"
            @click="cancelOperation"
          ></el-button>
        </div>
      </div>
    </div>

    <el-form>
      <el-input v-model="editForm.name" placeholder="Name">
        <template slot="prefix">Name</template>
      </el-input>
      <div class="inline-form-group">
        <el-tag class="mb-2 mt-5" type="warning">
          <i class="el-icon-warning" style="margin-right: 4px;"></i>
          Start Key must be &gt;&equals; 1 and End Key must be &gt; Start Key.
        </el-tag>
      </div>
      <div class="inline-form-group">
        <el-col :span="11">
          <el-input
            v-model.number="editForm.start"
            type="number"
            placeholder="Start Key"
          >
            <template slot="prefix">Start Key</template>
          </el-input>
        </el-col>
        <el-col :span="2"> </el-col>
        <el-col :span="11">
          <el-input
            v-model.number="editForm.end"
            type="number"
            placeholder="End Key"
          >
            <template slot="prefix">End Key</template>
          </el-input>
        </el-col>
      </div>
      <key-assignments
        :validKeyRange="validKeyRange"
        :startKey="editForm.start"
        :endKey="editForm.end"
        :selectedKeys="selectedKeys"
        @keysSelected="onKeysSelection"
      />
    </el-form>
  </el-dialog>
</template>

<script>
import KeyAssignments from "./keyAssignments.vue";

export default {
  name: "ButtonLayoutsEditForm",

  props: {
    editVisible: { required: true },
    clearFormFields: { required: true },
    editProcessing: { required: true },
    selectedButtonLayout: { required: true }
  },

  components: {
    KeyAssignments
  },

  data() {
    return {
      selectedKeys: null,
      editForm: {
        tenantId: null,
        name: "",
        start: "",
        end: "",
        keys: []
      }
    };
  },

  computed: {
    selectedTenant() {
      return this.$store.state.selectedTenant;
    },

    validKeyRange() {
      return (
        +this.editForm.start >= 1 && +this.editForm.end > +this.editForm.start
      );
    }
  },

  watch: {
    clearFormFields(value) {
      if (value) {
        this.clearFields();
      }
    },

    selectedButtonLayout(val) {
      if (val) {
        const { name, start, end, keys } = val;
        this.editForm.name = name;
        this.editForm.start = start;
        this.editForm.end = end;
        this.selectedKeys = [...keys];
      }
    }
  },

  methods: {
    onKeysSelection(keys) {
      this.editForm.keys = [...keys];
    },

    editOperation() {
      if (!this.validKeyRange) {
        this.$notify({
          title: "Invalid Key Range",
          message: "Start Key must be >= 1 and End Key must be > Start Key.",
          type: "error"
        });
        return;
      }
      this.editForm.tenantId = this.selectedTenant.id;
      const editBody = { ...this.editForm };
      editBody.keys = editBody.keys.map(({ type, name, number }) => ({
        type,
        name,
        number
      }));
      this.$emit("editOperation", editBody);
    },

    cancelOperation() {
      this.$emit("cancelOperation", "edit");
    },

    clearFields() {
      this.selectedKeys = null;
      this.editForm = {
        tenantId: null,
        name: "",
        start: "",
        end: "",
        keys: []
      };
    }
  }
};
</script>
